import { Button } from '@/components/ui/button'
import { CardHeader, CardTitle, Card, CardContent } from '@/components/ui/Card'
import useResendVerificationEmailNotification from '@/services/api/auth/useResendVerificationEmailNotification'
import React from 'react'

export default function RegisterSuccess({ email, goBack, ...props }) {
  const { resend, resendStatus } = useResendVerificationEmailNotification()
  return (
    <Card {...props}>
      <CardHeader>
        <CardTitle>Check your email</CardTitle>
      </CardHeader>

      <CardContent className="font-normal text-txt-primary">
        {resendStatus.status === 'success' ? (
          <p>
            We've resent instructions to
            <span className="font-semibold">{email}</span> if it is an email on
            file. Please check again. If you still haven't received an email,{' '}
            <Button
              variant="link"
              className="h-auto p-0 underline"
              onClick={goBack}
            >
              try a different email
            </Button>
            .
          </p>
        ) : (
          <p>
            Thank you for signing up for ProfitFlow. We need to verify that
            email address you provided{' '}
            <span className="font-semibold">{email}</span> is correct. We have
            sent you an email with instructions. If you haven't received an
            email in 10 minutes, check your spam,{' '}
            <Button
              disabled={resendStatus.status === 'pending'}
              type="button"
              onClick={() => resend(email)}
              variant="link"
              className="h-auto p-0 underline"
            >
              resend
            </Button>
            , or try a{' '}
            <Button
              variant="link"
              className="h-auto p-0 underline"
              onClick={() => goBack()}
            >
              different email
            </Button>
            .
          </p>
        )}
      </CardContent>
    </Card>
  )
}
